export { Display } from './display';
export type { DisplayProps } from './display';
export { Title } from './title';
export type { TitleProps } from './title';
export { Label } from './label';
export type { LabelProps } from './label';
export { Paragraph } from './paragraph';
export type { ParagraphProps } from './paragraph';
